import { render, staticRenderFns } from "./supplementary.vue?vue&type=template&id=2d1945ee&scoped=true"
import script from "./supplementary.vue?vue&type=script&lang=js"
export * from "./supplementary.vue?vue&type=script&lang=js"
import style0 from "./supplementary.vue?vue&type=style&index=0&id=2d1945ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1945ee",
  null
  
)

export default component.exports